'use client'

import { useTranslation } from '@shared/config/i18n'
import { useMemo } from 'react'

const usePaymentErrorStaticModel = () => {
  const t = useTranslation()
  const ERROR_MESSAGES = useMemo(
    () =>
      ({
        IMP_UID_NOT_FOUND: t('payment.errors.impUidNotFound'),
        PAYMENT_FAILED: t('payment.errors.paymentFailed'),
        CARD_REGISTRATION_FAILED: t('payment.errors.cardRegistrationFailed'),
        PAYMENT_QUEUE_FAILED: t('payment.errors.paymentQueueFailed'),
        MAX_ATTEMPTS_EXCEEDED: t('payment.errors.maxAttemptsExceeded'),

        FREE_TRIAL_PAYMENT_FAILED: t('payment.errors.freeTrialPaymentFailed'),
      }) as const,
    [t],
  )

  return useMemo(() => ({ ERROR_MESSAGES }), [ERROR_MESSAGES])
}

export default usePaymentErrorStaticModel
